import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'anf-core-react';
import BreakpointContext from '../../../contexts/BreakpointContext';
import useOurFabrics from '../../../tools/customHooks/useOurFabricDataHook';
import MaterialCard from '../../MaterialCard/MaterialCard';

export default function CompareFabricsModal({
  isOpenCompareFabricsModal, setIsOpenCompareFabricsModal,
}) {
  const breakpoints = useContext(BreakpointContext);

  const { loading, error, data } = useOurFabrics(isOpenCompareFabricsModal);

  if (!isOpenCompareFabricsModal) return null;
  if (loading) return null;
  if (error) return null;

  return (

    <Modal
      isOpen={isOpenCompareFabricsModal}
      isFullscreen={!breakpoints.xsmall}
      id="denim-details-modal"
      onClose={() => setIsOpenCompareFabricsModal(false)}
      className="compare-fabrics-modal"
    >
      <div className="scope-1892">
        <div className="our-fabrics-modal-container">
          {data.ourFabrics?.fabricDetails.map((fabric) => (
            <MaterialCard
              fabricImage=""
              fabricImageAltText=""
              fabricType={fabric.fabricType}
              fabricDescription={fabric.fabricDescription}
              scaleData={fabric.scaleData}
              shopAllLabel={fabric.shopAllLabel}
              brand={fabric.brand}
              isSelect={fabric.isSelect}
              onClick={() => {}}
              isMobile
            />
          ))}
        </div>
      </div>
    </Modal>
  );
}

CompareFabricsModal.propTypes = {
  isOpenCompareFabricsModal: PropTypes.bool.isRequired,
};
